// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table th.billing-ym,\n.el-table td.billing-ym {\n  width: 9.5em;\n}", ""]);
// Exports
module.exports = exports;
